import { SET_TopicTree, SET_TopicList, SET_KeywordList, SET_TopicTreeLearning, SET_TopicListLearning, SET_KeywordListLearning, SET_TopicTreeTest, SET_TopicListTest, SET_LearningContents, SET_MockTest, SET_ContentLimit } from "./data.types";

const defaultData = 
	{
		topicTree: [],
		topicList: [],
		keywordList: [],
		topicTreeLearning: [],
		topicListLearning: [],
		keywordListLearning: [],
		topicTreeTest:[],
		topicListTest:[],
		learningContents:[],
		mockTest:[],
		contentLimit:{}
	};

export default function getData(state=defaultData, action) {
	switch (action.type) {
		case SET_TopicTree:			
			return {...state, topicTree:action.data};
		case SET_TopicList:
			return {...state, topicList:action.data};	
		case SET_KeywordList:
			return {...state, keywordList:action.data};	
		case SET_TopicTreeLearning:
			return {...state, topicTreeLearning:action.data};	
		case SET_TopicListLearning:
			return {...state, topicListLearning:action.data};	
		case SET_KeywordListLearning:
			return {...state, keywordListLearning:action.data};	
		case SET_TopicTreeTest:
			return {...state, topicTreeTest:action.data};	
		case SET_TopicListTest:
			return {...state, topicListTest:action.data};	
		case SET_LearningContents:
			return {...state, learningContents:action.data};	
		case SET_MockTest:
			return {...state, mockTest:action.data};
		case SET_ContentLimit:
			return {...state, contentLimit:action.data};		
																				  
		default:
		  return state;
   }
   
}